import React, { useEffect, useState } from "react";
import { DashboardSummaryTab } from "../IndexOverviewPoint";
import { Col, ConfigProvider, Modal, Row, Table } from "antd";
import Input from "../../../../components/Input/Input";
import {
  ExclamationCircleOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import Text from "../../../../components/Text/Text";
import Permission from "../../../../components/Permission/Permission";
import { ActionBtn } from "../../../../components/Button/TableActionButton";
import Select from "../../../../components/Select/Select";
import { numberFormatter } from "../../../../utility/Formatter";
import { zoneDatasource } from "../../../../datasource/ZoneDatasource";
import { useEffectOnce } from "react-use";

export const ShopPointTab = ({
  isHideDashboard,
  data,
  page,
  pageSize,
  setPage,
  setPageSize,
}: {
  isHideDashboard?: boolean;
  data: any;
  page?: string;
  pageSize?: string;
  setPage?: any;
  setPageSize?: any;
}) => {
  const { companyType, companyCode } = JSON.parse(localStorage.getItem("company")!);
  const [modalPointExpiring, setModalPointExpiring] = useState<{
    open: boolean;
    name?: string;
    value?: number;
  }>({ open: false, name: undefined, value: undefined });
  const [zoneList, setZoneList] = useState<any>([]);

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(companyCode).then((res) => {
      setZoneList(res);
    });
  };
  useEffectOnce(() => {
    fetchZone();
  });

  const columns =
    companyType === "Fertilizer"
      ? [
          {
            title: "รหัสร้านค้า",
            dataIndex: "shopNo",
            key: "shopNo",
          },
          {
            title: "ร้าน Sub-Dealer",
            dataIndex: "shopName",
            key: "shopName",
          },
          {
            title: "เขต",
            dataIndex: "shopZone",
            key: "shopZone",
          },
          {
            title: "ปริมาณรวม (ตัน)",
            dataIndex: "sumQuantity",
            key: "sumQuantity",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "รออนุมัติแต้ม",
            dataIndex: "sumPointWaitApprove",
            key: "sumPointWaitApprove",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "sumPointApproved",
            key: "sumPointApproved",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่แลกแล้ว",
            dataIndex: "sumPointDecreased",
            key: "sumPointDecreased",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มหมดอายุ",
            dataIndex: "sumPointExpired",
            key: "sumPointExpired",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "",
            dataIndex: "action",
            key: "action",
            render: (value: any, row: any, index: number) => {
              return {
                children: (
                  <Row justify={"start"} gutter={8}>
                    <Col>
                      <Permission permission={["overviewPoint", "view"]}>
                        <ActionBtn
                          //onClick={() => navigate("/PromotionPage/detailFlashSale/" + id + "/detail")}
                          icon={<UnorderedListOutlined />}
                        />
                      </Permission>
                    </Col>
                  </Row>
                ),
              };
            },
          },
        ]
      : [
          {
            title: "รหัสร้านค้า",
            dataIndex: "shopNo",
            key: "shopNo",
          },
          {
            title: "ร้าน Dealer",
            dataIndex: "shopName",
            key: "shopName",
          },
          {
            title: "เขต",
            dataIndex: "shopZone",
            key: "shopZone",
          },
          {
            title: "แต้มรอกดรับสินค้า",
            dataIndex: "sumPointWaitApprove",
            key: "sumPointWaitApprove",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "sumPoint",
            key: "sumPoint",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
        ];

  return (
    <>
      {!isHideDashboard && (
        <>
          <DashboardSummaryTab data={[]} />
          <br />
        </>
      )}
      <Row justify='start' gutter={8}>
        <Col span={8}>
          <Input autoComplete='off' placeholder='รหัสร้าน / ชื่อร้าน' suffix={<SearchOutlined />} />
        </Col>
        <Col span={4}>
          <Select
            data={
              zoneList.map((z) => ({ label: z.zoneName, value: z.zoneName, key: z.zoneName })) || []
            }
            placeholder='เลือกเขต'
          />
        </Col>
        <Col span={9} />
        <Col span={3} style={{ display: "flex", alignItems: "center" }}>
          <Text color='Text3'>ทั้งหมด {data?.count || 0} รายการ</Text>
        </Col>
      </Row>
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={data?.data}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: Number(pageSize) || 10,
            current: Number(page) || 1,
            total: data?.count,
            showSizeChanger: false,
            position: ["bottomCenter"],
            onChange: (page, size) => {
              const nextPage = String(page);
              const nextSize = String(size);
              setPage(nextPage);
              setPageSize(nextSize);
            },
          }}
        />
      </ConfigProvider>
      {modalPointExpiring.open && (
        <ModalPointExpiring
          modalPointExpiring={modalPointExpiring}
          setModalPointExpiring={setModalPointExpiring}
        />
      )}
    </>
  );
};
const ModalPointExpiring = ({ modalPointExpiring, setModalPointExpiring }: any) => {
  const mockData = [
    {
      campaignName: "S001",
      point: `100 แต้ม`,
      expirationDate: "01 ธ.ค. 2024",
    },
    {
      campaignName: "S002",
      point: `200 แต้ม`,
      expirationDate: "15 ก.ค. 2024",
    },
  ];

  const columns = [
    {
      title: "ชื่อแคมเปญ",
      dataIndex: "campaignName",
      key: "campaignName",
      width: "50%",
    },
    {
      title: "ร้าน Sub-แต้มใกล้หมดอายุ 30 วัน",
      dataIndex: "point",
      key: "point",
    },
    {
      title: "วันแต้มหมดอายุ",
      dataIndex: "expirationDate",
      key: "expirationDate",
    },
  ];

  return (
    <Modal
      open={modalPointExpiring.open}
      onCancel={() => setModalPointExpiring({ open: false, name: undefined, value: undefined })}
      footer={null}
      centered
      width={800}
    >
      <div style={{ marginBottom: 16 }}>
        <Text fontWeight={700} level={3}>
          ร้านค้า: {modalPointExpiring.name}
        </Text>
        <br />
        <Text color='Text3'>แต้มใกล้หมดอายุ 30 วัน ทั้งหมด {modalPointExpiring.value} แต้ม </Text>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={mockData}
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      </ConfigProvider>
    </Modal>
  );
};
